import {Injectable} from "@angular/core";
import {EditCertificateDialogComponent, EditCertificateDialogData} from "./edit-certificate-dialog.component";
import {Unit} from "../../modelinterfaces/unit.model";
import {
  DialogOpener
} from "../../../../../user-portal/src/app/shared/components/dialogs/base-dialog/base-dialog.opener";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {DialogData} from "../../../../../user-portal/src/app/shared/components/dialogs/base-dialog/dialog-data.model";

@Injectable({providedIn: 'root'})
export class EditCertificateDialogOpener extends DialogOpener.Outputable<EditCertificateDialogData, Unit> {
  constructor(matDialog: MatDialog) {
    super(matDialog, EditCertificateDialogComponent)
  }

  protected override config(data: DialogData<EditCertificateDialogData>): MatDialogConfig {
    return {
      ...super.config(data),
      minWidth: 'min(440px, calc(100vw - 32px))',
      maxWidth: 'calc(100vw - 32px)',
    };
  }
}
